import axios from "axios";
import Cognito from "../utility/CognitoAuth";
import CookieService from "../services/CookieService";

const base_api = 'https://demo.tria.connectria.com';
const cloudAdvisorUrl = 'https://sx1vye3px8.execute-api.us-east-1.amazonaws.com/dev';

const CloudWatchService = {
  getAlarms: async function(regions,params ={}) {
    regions = regions.join(",") || ""
    const idToken = await Cognito.getIdToken();
    const orgId = CookieService.getCookie('OrganizationId');
    return await axios.get(`${cloudAdvisorUrl}/operations/get/cloudwatchalarms`, { 
      params: { regions, orgId }, 
      headers: { Authorization: idToken }
    });
  },
};

export default CloudWatchService;